const getCurrency = (country, continent) => {
    if (country.toLowerCase() === 'switzerland') {
        return 'CHF';
    }
    if (country.toLowerCase() === 'united kingdom') {
        return 'GBP';
    }
    if (continent.toLowerCase() === 'europe') {
        return 'EUR';
    }
    return 'USD';
};

export default {
    getCurrency,
}; 
